import { styled } from '@mui/material/styles';
import { PAGE_Z_INDEX } from '@/pages/document/DocumentViewer/DocumentFileView/PageView/components/StyledComponents';

export const OcrWordsRoot = styled('div', { label: 'OcrWordsRoot' })(() => ({
  position: 'absolute',
  inset: 0,
  userSelect: 'none',
  zIndex: PAGE_Z_INDEX.OCR_WORDS,
}));

export const OcrWordsSelectionCanvas = styled('canvas', { label: 'OcrWordsSelectionCanvas' })(() => ({
  position: 'absolute',
  inset: 0,
  zIndex: PAGE_Z_INDEX.OCR_WORDS + 1,
  userSelect: 'none',
}));

export const OcrWordsArea = styled('div', { label: 'OcrWordsArea' })(() => ({
  position: 'absolute',
  inset: 0,
  zIndex: PAGE_Z_INDEX.OCR_WORDS + 2,
  userSelect: 'none',
}));
